module.exports = __webpack_public_path__ + "img/car-1.2b648747.jpg";